import { LocalStorageKeys } from '../config/globalVariables';

// Hotjar ładujemy dopiero po zgodzie (art. 399 PKE) — nigdy z public/index.html.
const HOTJAR_ID = 3867318;

export const COOKIE_SETTINGS_EVENT = 'berg:cookie-settings';

type Consent = 'true' | 'false' | null;

declare global {
  interface Window {
    hj?: ((...args: unknown[]) => void) & { q?: unknown[] };
    _hjSettings?: { hjid: number; hjsv: number };
  }
}

let analyticsLoaded = false;

export const getConsent = (): Consent => {
  try {
    const value = localStorage.getItem(LocalStorageKeys.CookiesConsent);
    return value === 'true' || value === 'false' ? value : null;
  } catch {
    return null;
  }
};

const addScript = (src: string) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

export const loadAnalytics = (): void => {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  const hj: NonNullable<Window['hj']> = function () {
    // eslint-disable-next-line prefer-rest-params
    (hj.q = hj.q || []).push(arguments);
  };
  window.hj = window.hj || hj;
  window._hjSettings = { hjid: HOTJAR_ID, hjsv: 6 };
  addScript(`https://static.hotjar.com/c/hotjar-${HOTJAR_ID}.js?sv=6`);
};

const ANALYTICS_COOKIE = /^_hj/;

// Hotjar zapisuje cookies także na domenie nadrzędnej (np. .bergregions.pl).
export const clearAnalyticsCookies = (): void => {
  const hostParts = window.location.hostname.split('.');
  const domains = hostParts.map((_, i) => hostParts.slice(i).join('.'));
  document.cookie
    .split(';')
    .map((entry) => entry.split('=')[0].trim())
    .filter((name) => ANALYTICS_COOKIE.test(name))
    .forEach((name) => {
      const expire = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      document.cookie = expire;
      domains.forEach((domain) => {
        document.cookie = `${expire}; domain=.${domain}`;
      });
    });
};

export const setConsent = (value: 'true' | 'false'): void => {
  const previous = getConsent();
  try {
    localStorage.setItem(LocalStorageKeys.CookiesConsent, value);
  } catch {
    // Bez storage decyzja obowiązuje tylko do przeładowania.
  }
  if (value === 'true') {
    loadAnalytics();
    return;
  }
  clearAnalyticsCookies();
  // Załadowanych skryptów nie da się wyładować — przeładowanie strony
  // uruchamia ją od nowa już bez nich.
  if (previous === 'true' || analyticsLoaded) window.location.reload();
};

export const openCookieSettings = (): void => {
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
};

export const resetCookieConsentForTests = (): void => {
  analyticsLoaded = false;
};
